export default "__VITE_ASSET__DqRA2xQL__"